import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TABS_MO_HINH } from '../data/templates.js';
import { taiVe } from '../lib/xuatExcel.js';
import { ghiNhanTaiMau, useMau } from '../lib/templates.js';
import { DINH_DANG, dinhDangKichThuoc } from '../lib/templateModel.js';

/** Lượt tải bản tiếng Anh được đếm riêng: "<slug>:en". */
const maDem = (slug, ngonNgu) => (ngonNgu === 'en' ? `${slug}:en` : slug);

function ChonNgonNgu({ id, value, onChange }) {
  return <div className="mau-ngon-ngu" role="radiogroup" aria-label="Ngôn ngữ của tệp">
    {[['vi', 'Tiếng Việt'], ['en', 'English']].map(([k, nhan]) => <label key={k} className={value === k ? 'dang-chon' : ''}>
      <input type="radio" name={`nn-${id}`} value={k} checked={value === k} onChange={() => onChange(k)} /> {nhan}
    </label>)}
  </div>;
}

/**
 * Khối tải mẫu. Hai loại:
 *  - 'sinh': sinh ngay trên máy người dùng từ code dùng chung với các công cụ,
 *    không cần đăng nhập, không tải file từ máy chủ. Tên công ty là tuỳ chọn.
 *  - 'tep':  tệp dựng sẵn trên Storage, tải thẳng về.
 * Truyền `mau` khi trang cha đã có dữ liệu; nếu không, khối tự tìm theo `slug`.
 */
export default function TemplateDownload({ slug, mau: mauCo, hienChiTiet = false }) {
  const tim = useMau(mauCo ? '' : slug);
  const mau = mauCo || tim.mau;
  if (!mau) return null;
  if (mau.kind === 'dashboard') return <TheDashboard mau={mau} />;
  return mau.kind === 'tep'
    ? <TaiTep mau={mau} hienChiTiet={hienChiTiet} />
    : <TaiSinh mau={mau} hienChiTiet={hienChiTiet} />;
}

/**
 * Nút tải đặt ngay dưới tiêu đề trang chi tiết, để khách không phải cuộn qua
 * ảnh và mô tả mới thấy nút (Clarity 06/10: khách đọc 11 phút, nút nằm ở
 * khoảng 60% trang, không bấm). Mẫu dựng sẵn tải thẳng; mẫu sinh trên trình
 * duyệt cần chọn ngôn ngữ/tên công ty nên nút cuộn xuống khối #tai-mau.
 */
export function NutTaiNhanh({ mau }) {
  const [daTai, setDaTai] = useState(false);
  const cuonToiKhoiTai = (e) => {
    const el = typeof document !== 'undefined' && document.getElementById('tai-mau');
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const soPhan = mau.kind === 'tep' ? (mau.tabs?.length || 0) : TABS_MO_HINH.length;
  const ghiChu = ['Miễn phí, không cần tài khoản', soPhan > 0 && `${soPhan} phần trong tệp`].filter(Boolean).join(' · ');
  if (mau.kind !== 'tep') {
    return <div className="mau-tai-nhanh">
      <a className="nut" href="#tai-mau" onClick={cuonToiKhoiTai}>Tải mẫu .xlsx miễn phí ↓</a>
      <span className="nho">{ghiChu}</span>
    </div>;
  }
  const coEn = Boolean(mau.fileEnUrl);
  return <div className="mau-tai-nhanh">
    <a className="nut" href={mau.fileUrl} download={mau.fileName || true} rel="noopener"
      onClick={() => { setDaTai(true); ghiNhanTaiMau(mau.slug); }}>
      {coEn ? 'Tải bản tiếng Việt' : 'Tải mẫu'} .{mau.fileFormat}
    </a>
    {coEn && <a className="nut phu" href={mau.fileEnUrl} download={mau.fileEnName || true} rel="noopener" hrefLang="en"
      onClick={() => { setDaTai(true); ghiNhanTaiMau(maDem(mau.slug, 'en')); }}>
      English version .{mau.fileEnFormat}
    </a>}
    <span className="nho">{daTai ? 'Đang tải xuống. Đọc phần “Sau khi tải” bên dưới để bắt đầu.' : ghiChu}</span>
  </div>;
}

function Khung({ mau, hienChiTiet, tabs, tieuDeTabs, children }) {
  return <aside className="mau-box">
    <p className="eyebrow">{mau.kind === 'tep' ? `Mẫu ${DINH_DANG[mau.fileFormat]?.label || ''}` : 'Mẫu Excel'}, miễn phí, không cần tài khoản</p>
    {hienChiTiet ? (tabs.length > 0 && <h2>{tieuDeTabs}</h2>) : <><h2>{mau.title}</h2><p>{mau.excerpt}</p></>}
    {hienChiTiet && tabs.length > 0 && <ul className="mau-tabs">{tabs.map((t) => <li key={t.ten}><strong>{t.ten}</strong>{t.moTa && `: ${t.moTa}`}</li>)}</ul>}
    {children}
    {!hienChiTiet && <Link className="doc-tiep" to={`/mau/${mau.slug}`}>Xem mẫu này có gì →</Link>}
  </aside>;
}

function TaiSinh({ mau, hienChiTiet }) {
  const [tenCongTy, setTenCongTy] = useState('');
  const [ngonNgu, setNgonNgu] = useState('vi');
  const [state, setState] = useState('idle');
  async function tai() {
    setState('working');
    try {
      const { dungTepMoHinhTaiChinh } = await import('@shared/excel/financialModelBook.js');
      const tep = dungTepMoHinhTaiChinh(mau.nganhMoHinh, { tenDoanhNghiep: tenCongTy.trim().slice(0, 120), ngonNgu });
      await taiVe(tep, ngonNgu === 'en' ? `${mau.tenFile}-en` : mau.tenFile);
      setState('done');
      ghiNhanTaiMau(maDem(mau.slug, ngonNgu));
    } catch (err) {
      console.error(err);
      setState('error');
    }
  }
  return <Khung mau={mau} hienChiTiet={hienChiTiet} tabs={TABS_MO_HINH} tieuDeTabs="Bốn tab trong tệp">
    <div className="mau-form">
      <ChonNgonNgu id={mau.slug} value={ngonNgu} onChange={(v) => { setNgonNgu(v); setState('idle'); }} />
      <label htmlFor={`ten-cty-${mau.slug}`}>Tên công ty để ghi vào đầu bảng <span className="nho">(không bắt buộc)</span></label>
      <div className="mau-hang">
        <input id={`ten-cty-${mau.slug}`} type="text" value={tenCongTy} onChange={(e) => setTenCongTy(e.target.value)} placeholder="Công ty TNHH ABC" />
        <button className="nut" type="button" onClick={tai} disabled={state === 'working'}>
          {state === 'working' ? 'Đang tạo tệp…' : ngonNgu === 'en' ? 'Download .xlsx (English)' : 'Tải mẫu .xlsx'}
        </button>
      </div>
      {state === 'done' && <p className="nho" role="status">{ngonNgu === 'en'
        ? 'Downloaded. Only enter numbers on the “Assumptions” tab; the other tabs are formulas.'
        : 'Đã tải xuống. Chỉ nhập số ở tab “Giả định”, các tab còn lại là công thức.'}</p>}
      {state === 'error' && <p className="story-loi" role="alert">Không tạo được tệp trên trình duyệt này. Bạn thử lại bằng Chrome hoặc Edge trên máy tính.</p>}
    </div>
  </Khung>;
}

function TaiTep({ mau, hienChiTiet }) {
  const [daTai, setDaTai] = useState(false);
  const coEn = Boolean(mau.fileEnUrl);
  const soSheet = mau.tabs?.length || 0;
  const meta = [
    mau.maMau && `Mã ${mau.maMau}`,
    mau.phienBan > 0 && `phiên bản ${mau.phienBan}`,
    dinhDangKichThuoc(mau.fileSize),
    mau.updatedAt && `cập nhật ${mau.updatedAt.split('-').reverse().join('/')}`,
  ].filter(Boolean).join(', ');
  return <Khung mau={mau} hienChiTiet={hienChiTiet} tabs={mau.tabs || []} tieuDeTabs={soSheet ? `${soSheet} phần trong tệp` : ''}>
    <div className="mau-form">
      <div className="mau-hang">
        <a className="nut" href={mau.fileUrl} download={mau.fileName || true} rel="noopener"
          onClick={() => { setDaTai(true); ghiNhanTaiMau(mau.slug); }}>
          {coEn ? 'Tải bản tiếng Việt' : 'Tải mẫu'} .{mau.fileFormat}
        </a>
        {coEn && <a className="nut phu" href={mau.fileEnUrl} download={mau.fileEnName || true} rel="noopener" hrefLang="en"
          onClick={() => { setDaTai(true); ghiNhanTaiMau(maDem(mau.slug, 'en')); }}>
          English version .{mau.fileEnFormat}
        </a>}
        {meta && <span className="nho mau-meta">{meta}</span>}
      </div>
      {daTai && <p className="nho" role="status">Đang tải xuống. Chỉ sửa các ô nhập liệu theo hướng dẫn trong tệp; phần còn lại là công thức.</p>}
      {hienChiTiet && mau.ghiChuPhienBan && <p className="nho">Thay đổi ở phiên bản này: {mau.ghiChuPhienBan}</p>}
    </div>
  </Khung>;
}

/** Dashboard tương tác không có tệp tải sẵn: thẻ dẫn sang trang dashboard (dùng trong bài Playbook). */
function TheDashboard({ mau }) {
  return <aside className="mau-box">
    <p className="eyebrow">Dashboard mẫu, miễn phí, không cần tài khoản</p>
    <h2>{mau.title}</h2>
    <p>{mau.excerpt}</p>
    <Link className="nut" to={`/mau/${mau.slug}`}>Mở dashboard →</Link>
  </aside>;
}
